import { Box } from '@mui/material';

import { closedNote, scoredByText, windowHeading, windowMode } from '../benchmarkMonitoring';
import type { BenchmarkMonitoring } from '../types';
import { ProgressBar } from './ProgressBar';
import { CARD_SX, COUNT_WIDTHS, CardHeading, CountCell, NameCell, ROW_SX, StatusHeaderRow } from './tableParts';

export function BenchmarksCard({ data, right }: { data: BenchmarkMonitoring; right?: string }) {
  const mode = windowMode(data);
  return (
    <Box component="section" data-testid="benchmarks-card" sx={CARD_SX}>
      <CardHeading title={windowHeading(data)} right={right} />
      <StatusHeaderRow first="Benchmark" mode={mode} />
      {data.benchmarks.map((row) => {
        const auto = row.scoredBy === 'auto';
        const of = row.counts.base;
        return (
          <Box key={row.key} data-testid="benchmark-row" sx={ROW_SX}>
            <NameCell name={row.label} sub={scoredByText(row.scoredBy)} />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <ProgressBar counts={row.counts} mode={mode} />
            </Box>
            <CountCell value={row.counts.scored} of={of} width={COUNT_WIDTHS[0]} />
            <CountCell value={row.counts.toScore} of={of} dash={auto} width={COUNT_WIDTHS[1]} />
            <CountCell value={row.counts.inProgress} of={of} width={COUNT_WIDTHS[2]} note={closedNote(row.counts, 'inProgress', mode.open)} />
            <CountCell value={row.counts.notStarted} of={of} width={COUNT_WIDTHS[3]} note={closedNote(row.counts, 'notStarted', mode.open)} />
          </Box>
        );
      })}
    </Box>
  );
}
